import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spin, Button } from 'antd';
import { rutaObservacions } from '../../routes/routeConstants';

import { onEnterObservacioExportacio } from '../../actions';
import ObservacioExportacioSelectorPeriode from './observacioExportacioSelectorPeriode';
import ObservacioExportacioVisualitzacio from './observacioExportacioVisualitzacio';
import { obtenirObservacionsExportacio, obtenirObservacionsExportacioPerEstacio } from '../../actions/observacio';
import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';

class ObservacioExportacio extends Component {

    componentDidMount() {
        this.props.onEnterObservacioExportacio();
    }

    render() {
        const { dataActual, dataInici, dataFi, estacions, idsEstacionsUsuari, periodes, peticioObservacionsEnCurs, estacionsActives, estacioSeleccionada } = this.props;
        const { obtenirObservacionsExportacio, obtenirObservacionsExportacioPerEstacio } = this.props;
        return (
            <div>
                <Link to={rutaObservacions}>
                    <Button icon='left'>
                        Tornar
                    </Button>
                </Link>
                <ObservacioExportacioSelectorPeriode
                    dataActual={dataActual}
                    estacioSeleccionada={estacioSeleccionada}
                    obtenirObservacionsExportacio={obtenirObservacionsExportacio}
                    obtenirObservacionsExportacioPerEstacio={obtenirObservacionsExportacioPerEstacio} />
                <Spin spinning={peticioObservacionsEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER}>
                    <ObservacioExportacioVisualitzacio
                        dataInici={dataInici}
                        dataFi={dataFi}
                        estacions={estacions}
                        estacionsActives={estacionsActives}
                        estacioSeleccionada={estacioSeleccionada}
                        idsEstacionsUsuari={idsEstacionsUsuari}
                        obtenirObservacionsExportacioPerEstacio={obtenirObservacionsExportacioPerEstacio} 
                        periodes={periodes} />
                </Spin>
            </div>
        );
    }
}

ObservacioExportacio.propTypes = {
    dataActual: PropTypes.string.isRequired,
    dataInici: PropTypes.string,
    dataFi: PropTypes.string,
    estacions: PropTypes.object,
    estacionsActives: PropTypes.object,
    estacioSeleccionada: PropTypes.number,
    idsEstacionsUsuari: PropTypes.array,
    periodes: PropTypes.object,
    obtenirObservacionsExportacio: PropTypes.func,
    obtenirObservacionsExportacioPerEstacio: PropTypes.func,
    peticioObservacionsEnCurs: PropTypes.bool,
    onEnterObservacioExportacio: PropTypes.func
};

const mapStateToProps = (state) => ({
    dataActual: state.dataActual,
    dataInici: state.observacio.exportacio.dataInici,
    dataFi: state.observacio.exportacio.dataFi,
    estacions: state.observacio.exportacio.tots.estacions,
    estacionsActives: state.observacio.exportacio.tots.estacionsActives,
    estacioSeleccionada: state.observacio.exportacio.estacioSeleccionada,
    idsEstacionsUsuari: state.observacio.exportacio.tots.estacionsUsuari,
    periodes: state.observacio.exportacio.tots.periodes,
    peticioObservacionsEnCurs: state.observacio.exportacio.peticioObservacionsEnCurs
});

export default connect(mapStateToProps, { onEnterObservacioExportacio, obtenirObservacionsExportacio, obtenirObservacionsExportacioPerEstacio })(ObservacioExportacio);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioExportacio.js